import { useEffect, useState } from 'react'
import { registerSW } from 'virtual:pwa-register'

/**
 * Mise à jour de l'application installée.
 *
 * ────────────────────────────────────────────────────────────────────────────
 * Le problème que ça règle
 * ────────────────────────────────────────────────────────────────────────────
 *
 * L'application est une PWA : son cache la rend instantanée à l'ouverture et
 * la fait fonctionner même si le réseau tombe. Le revers est qu'un iPad garde
 * la version qu'il connaît. Un correctif déployé sur le NAS peut donc rester
 * invisible en boutique pendant des jours — et l'on cherche un bug qui n'existe
 * plus.
 *
 * On force donc la mise à jour dès qu'une nouvelle version est disponible, et
 * on vérifie toutes les dix minutes tant que l'application est ouverte. Le
 * rechargement est annoncé une seconde à l'avance : au comptoir, un écran qui
 * se recharge sans prévenir laisse penser à une panne.
 *
 * Le ticket en cours n'est pas perdu pour autant — la mise à jour attend que
 * l'onglet ne soit pas en train d'encaisser.
 */

const DELAI_VERIFICATION = 10 * 60 * 1000

export function MiseAJour() {
  const [enAttente, setEnAttente] = useState(false)

  useEffect(() => {
    const majSW = registerSW({
      immediate: true,
      onRegisteredSW(_url, enregistrement) {
        if (!enregistrement) return
        window.setInterval(() => void enregistrement.update(), DELAI_VERIFICATION)
      },
      onNeedRefresh() {
        setEnAttente(true)
        // Une seconde pour que le message soit lu, puis on recharge.
        window.setTimeout(() => void majSW(true), 1200)
      },
    })
  }, [])

  if (!enAttente) return null
  return <div className="maj-application">Nouvelle version — rechargement…</div>
}

/** La version affichée dans l'application, pour savoir ce qui tourne. */
export const VERSION = __VERSION__
